<template>
    <div class="indexpage">
        <el-menu :default-active="activeIndex" router=true class="el-menu-demo" mode="horizontal"
                background-color="#409EFF" text-color="#fff" active-text-color="#67C23A"
                style="top:0%">
            <el-menu-item index="/search">查询商品</el-menu-item>
            <el-menu-item index="/add">添加商品</el-menu-item>
            <el-menu-item index="/live">直播中心</el-menu-item>
            <el-menu-item index="/memo">备忘中心</el-menu-item>
            <el-menu-item index="/file">文件中心</el-menu-item>
            <el-menu-item index="/inventory">盘货中心</el-menu-item>
            <el-menu-item index="/user">个人中心</el-menu-item>
            <el-menu-item index="/detail">商品详情</el-menu-item>
        </el-menu>
    </div>
</template>

<script>
export default {
  name: 'IndexPage',
  data () {
    return {
      activeIndex: '1'
    }
  },
  mounted () {
  },

  methods: {
    // handleSelect (key, keyPath) {
    //   // eslint-disable-next-line eqeqeq
    //   if (key == 1) {
    //     this.$router.push('/search')
    //   // eslint-disable-next-line eqeqeq
    //   } else if (key == 2) {
    //     this.$router.push('/add')
    //   // eslint-disable-next-line eqeqeq
    //   } else if (key == 3) {
    //     this.$router.push('/live')
    //   // eslint-disable-next-line eqeqeq
    //   } else if (key == 6) {
    //     this.$router.push('/user')
    //   // eslint-disable-next-line eqeqeq
    //   } else if (key == 4) {
    //     this.$router.push('/memo')
    //   // eslint-disable-next-line eqeqeq
    //   } else if (key == 5) {
    //     this.$router.push('/file')
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/IndexPage.vue